import { useQuery } from '@tanstack/react-query';
import { AxiosRequestConfig } from 'axios';

import { api } from '_core/api/api-nextjs-proxy';
import { usePublicAppContext } from '_core/context/public-app-context';

export type Language = {
  code: string;
  name: string;
};

const cacheKey = {
  languages: (locale: string) => `/api/proxy/languages/all-languages?locale=${locale}`,
};

const urls = {
  languages: (locale: string) => `/api/proxy/languages/all-languages?locale=${locale}`,
};

export const languagesRepo = {
  getLanguages: async (config?: AxiosRequestConfig): Promise<Language[]> => {
    const { locale = 'en' } = config?.headers || {};
    const returnObject = await api.get(urls.languages(locale), config);
    return returnObject?.data?.data?.languages;
  },
};

export const useLanguages = (lang?: string) => {
  const { domainInfo, locale: appLocale } = usePublicAppContext();
  const baseURL = domainInfo?.getOriginUrl() ?? '';
  const locale = lang ? lang : appLocale || 'en';
  const headers = { locale };

  return useQuery({
    queryKey: [cacheKey.languages(locale)],
    queryFn: () => {
      return languagesRepo.getLanguages({ baseURL, headers });
    },
  });
};
